import { RouteInterface, RoutesInterface } from '../../../types/routes';

export const assuranceRouteEntry: RouteInterface = {
  id: 'assurance_root',
  label: 'Assurance Tracker',
  tooltip: 'Assurance Tracker',
  path: '/assurance',
  icon: 'fa-folder-open',
  appPermissionId: 'app_assurance',
  exact: false,
  auth: true,
};

export const assuranceOtherRoutes: RoutesInterface = {
  ASSURANCE_PORTFOLIO: {
    id: 'assurance_portfolio',
    label: 'Assurance Tracker',
    tooltip: 'Assurance Tracker',
    path: '/assurance/portfolio/:assurancePortfolioId/:questionId?/:index?',
    icon: 'fa-folder-open',
    appPermissionId: 'app_assurance',
    exact: false,
    auth: true,
  },
  ASSURANCE_MANAGE_USERS: {
    id: 'assurance_manage_users',
    label: 'Manage Users',
    path: '/assurance/manage-users/:page(invite)?',
    auth: true,
    // Should come up with a way to check assurance permission roles per route
  }
}

export const assuranceRoutes: RoutesInterface = {
  ASSURANCE: assuranceRouteEntry,
  ...assuranceOtherRoutes
}
